import React from 'react';

interface TabNavigationProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'badges', label: 'Digital Badges' },
    { id: 'passport', label: 'Digital Passport' }
  ];

  return (
    <section className="tabs-section">
      <div className="tabs-container rounded-full mx-auto p-0">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab-button py-1 ${activeTab === tab.id ? 'active rounded-full mx-auto' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </section>
  );
};

export default TabNavigation;